import { Link } from "gatsby"
import React, { useState } from "react"
import {
  faFacebookF,
  faInstagram,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons"
import inheaden from "../images/inheaden.svg"
import "./design.scss"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useTranslation } from "react-i18next"
export function Footer() {
  const { t, i18n } = useTranslation()
  const newLanguage = i18n.language === "en" ? "de" : "en"
  function changeBackground(e) {
    e.target.style.color = "white"
  }
  function unchangeBackground(e) {
    e.target.style.color = "gray"
  }

  return (
    <div className=" footer ">
      <ul>
        <li>
          <a
            id="Footer-Facbook"
            href="https://www.facebook.com/pages/category/Tourist-Information-Center/folofrankfurt-106691087339615"
            className="social-media"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon icon={faFacebookF} size="1x" />
          </a>
        </li>
        <li>
          <a
            id="Footer-instagram"
            href="https://www.instagram.com/folo.club/?hl=en"
            className="social-media"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon icon={faInstagram} size="1x" />
          </a>
        </li>
        <li>
          <a
            id="Footer-linkedin"
            href="https://de.linkedin.com/company/foloaround"
            className="social-media"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon icon={faLinkedin} size="1x" />
          </a>
        </li>
        <li id="datapolicy">
          <Link to="/datapolicy">{t("Datapolicy")}</Link>
        </li>

        <li>
          <Link to="/imprint">{t("Imprint")}</Link>
        </li>
        {/* <li>
          <button
            id="translate"
            style={{
              textTransform: "uppercase",
              cursor: "pointer",
              color: " gray",
              backgroundColor: "transparent",
              border: "none",
            }}
            className="language-btn"
            onClick={() => i18n.changeLanguage(newLanguage)}
            onMouseEnter={changeBackground}
            onMouseLeave={unchangeBackground}
          >
            {newLanguage}
          </button>
        </li> */}
      </ul>

      <a
        id="inheaden-logo"
        href="http://inheaden.io"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="https://cdn.inheaden.cloud/brand/Powered%20By/PowLogo_SW.svg"
          alt="Powered by Inheaden"
          width="80"
        />
      </a>
    </div>
  )
}
export default Footer
